'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SidebarToggleStyled = undefined;

var _templateObject = _taggedTemplateLiteral(['\n        ', '\n      '], ['\n        ', '\n      ']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var propTypes = {
  expanded: _propTypes2.default.bool,
  autoCollapsing: _propTypes2.default.bool,
  theme: _propTypes2.default.object
};

var defaultProps = {
  expanded: false,
  autoCollapsing: false
};

/** Prop Receivers */
var style = function style(_ref) {
  var themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var backgroundColor = theme.reactackle.components.sidebar.sidebar.backgroundColor;


  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];

  return '\n    background-color: ' + backgroundColor + ';\n    \n    &,\n    & *,\n    *::after,\n    *::before {\n      font-family: ' + fontFamily + ';\n      box-sizing: border-box;\n    }\n  ';
};

var base = function base(_ref2) {
  var themeFromProvider = _ref2.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.sidebar.toggleButton,
      height = _theme$reactackle$com.height,
      fontSize = _theme$reactackle$com.fontSize,
      lineHeight = _theme$reactackle$com.lineHeight,
      fontWeight = _theme$reactackle$com.fontWeight,
      textTransform = _theme$reactackle$com.textTransform,
      zIndex = _theme$reactackle$com.zIndex,
      paddingRight = _theme$reactackle$com.paddingRight;


  return '\n    z-index: ' + zIndex + ';\n    margin-top: -' + (0, _reactackleCore.getValueString)(height) + ';\n    height: ' + (0, _reactackleCore.getValueString)(height) + ';\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    font-weight: ' + fontWeight + ';\n    line-height: ' + lineHeight + ';\n    text-transform: ' + textTransform + ';\n    padding-right: ' + (0, _reactackleCore.getValueString)(paddingRight) + ';\n  ';
};

var state = function state(_ref3) {
  var themeFromProvider = _ref3.theme,
      expanded = _ref3.expanded,
      autoCollapsing = _ref3.autoCollapsing;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var sidebarPath = theme.reactackle.components.sidebar.sidebar,
      togglePath = theme.reactackle.components.sidebar.toggleButton.style,
      widthChangingBreakpoint = sidebarPath.widthChangingBreakpoint,
      expandedWidthValue = (0, _reactackleCore.getValueString)(sidebarPath.state.expanded.width);


  var collapsedStyles = '\n    width: ' + expandedWidthValue + ';\n    background-color: ' + togglePath.collapsed.backgroundColor + ';\n    color: ' + togglePath.collapsed.fontColor + ';\n    \n    &:hover {\n      background-color: ' + togglePath.collapsed.hover.backgroundColor + ';\n      color: ' + togglePath.collapsed.hover.fontColor + ';\n    }\n    \n    &:focus {\n      background-color: ' + togglePath.collapsed.focus.backgroundColor + ';\n      color: ' + togglePath.collapsed.focus.fontColor + ';\n    }\n  ';

  var expandedStyles = '\n    width: ' + expandedWidthValue + ';\n    background-color: ' + togglePath.expanded.backgroundColor + ';\n    color: ' + togglePath.expanded.fontColor + ';\n    \n    &:hover {\n      background-color: ' + togglePath.expanded.hover.backgroundColor + ';\n      color: ' + togglePath.expanded.hover.fontColor + ';\n    }\n    \n    &:focus {\n      background-color: ' + togglePath.expanded.focus.backgroundColor + ';\n      color: ' + togglePath.expanded.focus.fontColor + ';\n    }\n  ';

  if (autoCollapsing) {
    return (0, _styledComponents.css)(['', ' ', ''], expanded ? expandedStyles : collapsedStyles, (0, _reactackleCore.media)(widthChangingBreakpoint)(_templateObject, !expanded ? collapsedStyles : expandedStyles));
  } else {
    return (0, _styledComponents.css)(['', ''], !expanded ? collapsedStyles : expandedStyles);
  }
};

/** Styles */
var SidebarToggleStyled = exports.SidebarToggleStyled = _styledComponents2.default.button.withConfig({
  displayName: 'SidebarToggleStyled'
})(['position:absolute;cursor:pointer;text-align:left;display:flex;align-items:center;user-select:none;padding:0;z-index:1;&,&:hover,&:focus{border:0;outline:none;box-shadow:none;}', ' ', ' ', ' ', ';'], base, style, state, (0, _reactackleCore.transition)('width, background-color'));

SidebarToggleStyled.propTypes = propTypes;
SidebarToggleStyled.defaultProps = defaultProps;
SidebarToggleStyled.displayName = 'SidebarToggleStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-sidebar/dist/SidebarToggle/styles/SidebarToggleStyled.js
// module id = 803
// module chunks = 0